import { Switch } from 'react-router-dom';
import Route from './Route';
import ScrollToTop from '../ScrollToTop';

import SignIn from '../pages/Login';
import SignUp from '../pages/SignUp';
import ResetPassword from '../pages/ResetPassword';
import HomeUserPage from '../pages/home-user';
import HomeAdminPage from '../pages/home-admin';
import MudasPage from '../pages/mudas';
import CadastrarMudasPage from '../pages/mudas/create';
import EditarMudasPage from '../pages/mudas/edit';
import LogsPage from '../pages/logs/index';
import EditarLogsPage from '../pages/logs/edit';
import CampanhaPage from '../pages/campanha';
import CadastrarCampanhaPage from '../pages/campanha/create';
import EditarCampanhaPage from '../pages/campanha/edit';
import PessoaPage from '../pages/pessoa';
import CadastrarPessoaPage from '../pages/pessoa/create';
import EditarPessoaPage from '../pages/pessoa/edit';
import PessoaCampanhaMudasPage from '../pages/pessoaCampanhaMudas';

export default function Routes() {
  return (
    <ScrollToTop>
      <Switch>
        <Route exact path="/" component={HomeUserPage} />
        <Route exact path="/register" component={SignUp} />
        <Route exact path="/login" component={SignIn} />
        <Route exact path="/reset" component={ResetPassword} />
        <Route exact path="/admin" component={HomeAdminPage} isPrivate />
        <Route exact path="/mudas" component={MudasPage} isPrivate />
        <Route exact path="/mudascreate" component={CadastrarMudasPage} isPrivate />
        <Route exact path="/mudas/edit/:id" component={EditarMudasPage} isPrivate /> 
        <Route exact path="/logs" component={LogsPage} isPrivate />
        <Route exact path="/logs/edit/:id" component={EditarLogsPage} isPrivate /> 
        <Route exact path="/campanha" component={CampanhaPage} isPrivate />
        <Route exact path="/campanhacreate" component={CadastrarCampanhaPage} isPrivate />
        <Route exact path="/campanha/edit/:id" component={EditarCampanhaPage} isPrivate /> 
        <Route exact path="/pessoa" component={PessoaPage} isPrivate />
        <Route exact path="/pessoacreate" component={CadastrarPessoaPage} isPrivate />
        <Route exact path="/pessoa/edit/:id" component={EditarPessoaPage} isPrivate />
        <Route exact path="/pessoacampanha" component={PessoaCampanhaMudasPage} isPrivate /> 
      </Switch>
    </ScrollToTop>
  )
}